import React from 'lib/react';
import { EVHelpOutline, EVTooltip } from 'lib/components';
import PropTypes from 'prop-types';
import HelpTooltipStyles from './HelpTooltipStyles';

function HelpTooltip(props) {
  const { title } = props;
  const classes = HelpTooltipStyles();

  return (
    <EVTooltip
      arrow
      interactive
      classes={{ arrow: classes.arrow, tooltip: classes.tooltip }}
      title={title}
      placement="top"
    >
      <span className={classes.helpIcon}>
        <EVHelpOutline color="primary" tabIndex="0" />
      </span>
    </EVTooltip>
  );
}

HelpTooltip.propTypes = {
  title: PropTypes.string.isRequired,
};

export default HelpTooltip;
